import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSpinRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconArrowSpinRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.748 10.292a.45.45 0 0 0 .9 0v-.31c.367.352.834.627 1.301.825.877.372 1.916.548 2.722.407 1.459-.254 2.425-.816 2.805-1.195a.45.45 0 0 0-.635-.637c-.214.213-.992.713-2.324.946-.59.103-1.452-.024-2.216-.35-.538-.228-.95-.523-1.198-.833l.672.129a.45.45 0 0 0 .17-.885l-1.662-.317-.535-.102zm4.263-6.375a2.095 2.095 0 0 0-2.095 2.094l.01.214a2.095 2.095 0 1 0 2.085-2.308m0 .9a1.193 1.193 0 1 1 0 2.388 1.193 1.193 0 0 1 0-2.387m2.052-3.602C7.186.843 6.147.667 5.34.808c-1.459.255-2.425.817-2.805 1.195a.45.45 0 0 0 .635.637c.213-.213.991-.713 2.324-.945.59-.103 1.451.024 2.216.348.538.229.95.524 1.198.834l-.673-.129a.45.45 0 0 0-.169.885l1.662.318.535.101V1.731a.45.45 0 0 0-.9 0v.308c-.367-.35-.834-.625-1.302-.824"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowSpinRight12);
